var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      attrs: { rules: _vm.rules, model: _vm.form, "label-width": "100px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "機台編號", prop: "AssetNo" } },
        [
          _c("el-input", {
            model: {
              value: _vm.form.AssetNo,
              callback: function ($$v) {
                _vm.$set(_vm.form, "AssetNo", $$v)
              },
              expression: "form.AssetNo",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "機台型號" } },
        [
          _c(
            "el-select",
            {
              staticClass: "mr-3",
              attrs: { placeholder: "選擇機型" },
              on: { change: _vm.onModelSelectChange },
              model: {
                value: _vm.form.model.id,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "id", $$v)
                },
                expression: "form.model.id",
              },
            },
            _vm._l(_vm.mvmModels, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "機台位置", prop: "locate.name" } },
        [
          _c(
            "el-input",
            {
              model: {
                value: _vm.form.locate.name,
                callback: function ($$v) {
                  _vm.$set(_vm.form.locate, "name", $$v)
                },
                expression: "form.locate.name",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "append", type: "success" },
                  on: { click: _vm.getGeoCode },
                  slot: "append",
                },
                [_vm._v("定位")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "客戶名稱" } },
        [
          _c("selectClient", {
            attrs: {
              "client-id": _vm.form.client.id,
              "company-id": _vm.companyId,
            },
            on: {
              "update:clientId": function ($event) {
                return _vm.$set(_vm.form.client, "id", $event)
              },
              "update:client-id": function ($event) {
                return _vm.$set(_vm.form.client, "id", $event)
              },
              onSelect: _vm.onSelectClient,
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "巡補員" } },
        [
          _c("selectUser", {
            attrs: { "user-id": _vm.form.user.id, "company-id": _vm.companyId },
            on: {
              "update:userId": function ($event) {
                return _vm.$set(_vm.form.user, "id", $event)
              },
              "update:user-id": function ($event) {
                return _vm.$set(_vm.form.user, "id", $event)
              },
              onSelect: _vm.onSelectUser,
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "發票啟用時間" } },
        [
          _c("el-date-picker", {
            attrs: {
              disabledDate: "",
              type: "date",
              placeholder: "點擊修改啟用時間",
              "picker-options": _vm.pickerOptions,
            },
            model: {
              value: _vm.form.invoice_settings.EnableSince,
              callback: function ($$v) {
                _vm.$set(_vm.form.invoice_settings, "EnableSince", $$v)
              },
              expression: "form.invoice_settings.EnableSince",
            },
          }),
          _c("br"),
          _c("el-switch", {
            attrs: {
              "active-color": "#13ce66",
              "active-text": "啟用",
              "inactive-color": "#ff4949",
              "inactive-text": "不啟用",
            },
            model: {
              value: _vm.form.invoice_settings.Invoice,
              callback: function ($$v) {
                _vm.$set(_vm.form.invoice_settings, "Invoice", $$v)
              },
              expression: "form.invoice_settings.Invoice",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "備註" } },
        [
          _c("el-input", {
            attrs: { type: "textarea" },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              attrs: { loading: _vm.is_loading, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.onSubmit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.id ? "更新機台" : "建立機台"))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show_cancel,
                  expression: "show_cancel",
                },
              ],
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.show_cancel,
                  expression: "!show_cancel",
                },
              ],
              on: { click: _vm.onCancel },
            },
            [_vm._v("關閉")]
          ),
        ],
        1
      ),
      _vm.id
        ? _c(
            "el-collapse",
            {
              model: {
                value: _vm.collapse,
                callback: function ($$v) {
                  _vm.collapse = $$v
                },
                expression: "collapse",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { name: "1" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "text-danger" }, [
                      _vm._v("危險動作 "),
                      _c("i", { staticClass: "header-icon el-icon-warning" }),
                    ]),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "mr-3",
                      attrs: { placeholder: "機台狀態" },
                      model: {
                        value: _vm.form.Status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "Status", $$v)
                        },
                        expression: "form.Status",
                      },
                    },
                    _vm._l(_vm.Status, function (item) {
                      return _c("el-option", {
                        key: item.Status,
                        attrs: { label: item.name, value: item.Status },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    },
                    [_vm._v("設定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.is_loading, type: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.power("reboot")
                        },
                      },
                    },
                    [_vm._v("機台重新開機")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.is_loading, type: "danger" },
                      on: {
                        click: function ($event) {
                          return _vm.power("poweroff")
                        },
                      },
                    },
                    [_vm._v("機台關機")]
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }